import { render, staticRenderFns } from "./SlidesCarouselItem.vue?vue&type=template&id=0f0f96f6&scoped=true&"
import script from "./SlidesCarouselItem.vue?vue&type=script&lang=js&"
export * from "./SlidesCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./SlidesCarouselItem.vue?vue&type=style&index=0&id=0f0f96f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f96f6",
  null
  
)

export default component.exports